import { ReactElement } from 'react';

import {
  Button,
  Typography,
} from '@beeline/design-system-react/extracted-styles';

import cn from 'classnames';

import styles from './styles.module.scss';

import { ErrorImage } from ':components';

interface IErrorComponentProps {
  title: string;
  subtitle: string | ReactElement;
  buttonTitle: string;
  onButtonClick: () => void;
  className?: string;
}

export const ErrorComponent = ({
  title,
  subtitle,
  buttonTitle,
  onButtonClick,
  className,
}: IErrorComponentProps): ReactElement => {
  return (
    <section className={cn(styles.error, className)}>
      <ErrorImage className={styles.errorImage} />
      <Typography variant='h6' className={styles.title}>
        {title}
      </Typography>
      <Typography variant='subtitle2' className={styles.desc}>
        {subtitle}
      </Typography>
      <Button onClick={onButtonClick} variant='plain' size='medium'>
        {buttonTitle}
      </Button>
    </section>
  );
};
